'use client'

import { useQuery } from '@tanstack/react-query'

import { SyneriseCampaignRecommendationQueryParams } from 'lib/synerise'
import { QueryKey } from 'shared/api'

import { getRecommendedPersonalizedProducts } from '../api/recommendations'

interface UseQueryRecommendedPersonalizedProductsProps {
  token: string
  syneriseClientUUID: string
  distributionCenterId: string
}

const useQueryRecommendedPersonalizedProducts = ({
  token,
  syneriseClientUUID,
  distributionCenterId
}: UseQueryRecommendedPersonalizedProductsProps) => {
  const syneriseRecommendationQueryParams: SyneriseCampaignRecommendationQueryParams =
    {
      clientUUID: syneriseClientUUID || ''
    }

  return useQuery({
    queryKey: [
      QueryKey.recommendedPersonalizedProducts,
      token,
      syneriseClientUUID
    ],
    queryFn: () =>
      getRecommendedPersonalizedProducts({
        token,
        distributionCenterId,
        syneriseRecommendationQueryParams
      }),
    staleTime: 1000 * 60 // 1 minute
  })
}

export default useQueryRecommendedPersonalizedProducts
